import { render, staticRenderFns } from "./NodeNext.vue?vue&type=template&id=0a1b5b31"
import script from "./NodeNext.vue?vue&type=script&lang=js"
export * from "./NodeNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports